const experiences = [
  {
    heading: "Sanjay Ghodawat Olympiad School",
    sub: "Sangli",
    date: "Nov 2017 - 2021",
    description: "Class 12th",
    alignment: "left",
    type: "school",
  },
  {
    heading: "National Institute of Technology",
    sub: "Rourkela",
    date: "Nov 2022 - present",
    description: "Bachelor of Technology",
    alignment: "left",
    type: "school",
  },
  {
    heading: "Student Expert",
    sub: "Postman",
    date: "Feb 2023 - present",
    description:
      "completed course and became a student expert in Postman Student Expert Program.",
    alignment: "right",
    type: "commu",
  },
  {
    heading: "Lead Organiser",
    sub: "Google Developers Group, OnCampus NITR",
    date: "Nov 2022 - present",
    description:
      "Worked to organize various seminars and events which were attended by over 150 students. conducted workshops on various topics like Git and GitHub, Google Cloud Platform, etc.",
    alignment: "right",
    type: "commu",
  },
  {
    heading: "OpenSource Contributor",
    sub: "GirlScript Summer of Code",
    date: "Nov 2022 - present",
    description:
      "Worked on several opensource projects and contributed to them.",
    alignment: "left",
    type: "work",
  },
  {
    heading: "VP of Technology",
    sub: "Stethaim, early stage startup",
    date: "Nov 2022 - present",
    description:
      "Handled all technical aspects from building ML models to websites and deploying to cloud.",
    alignment: "left",
    type: "work",
  },
  {
    heading: "Founder and Orgnaiser",
    sub: "AWS userGroup Sangli-Kolhapur",
    date: "Aug 2024 - present",
    description:
      "Conducted worskhops, seminars and meetups on AWS for Students and Developers' community.",
    alignment: "left",
    type: "commu",
  },

  {
    heading: "SDE Intern",
    sub: "OpenGig",
    date: "Aug 2024 - Sep 2024",
    description: "Built products. Stack: Nest.js, express, node.js, Docker",
    alignment: "right",
    type: "work",
  },
];

export default experiences;
